var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: _vm.style },
    [
      _c("h1", { staticStyle: { "text-align": "center" } }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "v-chart",
        {
          attrs: {
            data: _vm.data,
            height: _vm.height,
            "force-fit": _vm.fix,
            onClick: _vm.handleClick,
            width: _vm.width
          }
        },
        [
          _c("v-tooltip"),
          _c("v-axis"),
          _c("v-legend"),
          _c("v-bar", {
            attrs: { position: "x*y", color: "type", adjust: _vm.adjust }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }